export const BOOKING_URL =
  'https://www.fresha.com/a/prep-beauty-parlour-vancouver-1305-burrard-street-hlh2s5oh';

export const PHONE_NUMBER = '604-764-6452';
export const PHONE_TEL = 'tel:+16047646452';

export const ADDRESS = '1305 Burrard St, Vancouver, BC';
// Embed that shows the business panel + rating inside the iframe (no API key needed)
export const MAP_EMBED =
  'https://maps.google.com/maps?q=Pr%C3%A9p+Beauty+Parlour+1305+Burrard+St+Vancouver&output=embed&iwloc=B';

// Google Business Profile (Knowledge Graph ID from share link)
export const GBP_URL = 'https://www.google.com/search?kgmid=/g/1tgywddd';
export const GBP_REVIEWS_URL =
  'https://www.google.com/search?kgmid=/g/1tgywddd#lrd=0x0:0x0,1';
export const GBP_DIRECTIONS_URL =
  'https://www.google.com/maps/dir/?api=1&destination=Pr%C3%A9p+Beauty+Parlour+1305+Burrard+St+Vancouver';
export const GBP_WRITE_REVIEW_URL =
  'https://search.google.com/local/writereview?kgmid=/g/1tgywddd';

export const PARENT_SITE = 'https://www.prepbeautyparlour.com/lash-lift-vancouver';

export const SOCIAL_HANDLE = '@prepbeautyparlour';
export const INSTAGRAM_URL = 'https://www.instagram.com/prepbeautyparlour';
export const TIKTOK_URL = 'https://www.tiktok.com/@prepbeautyparlour';
export const CLASSPASS_URL = 'https://classpass.com/studios/prp-beauty-parlour-vancouver';

// Real Prép Beauty Parlour assets (SEO-named filenames preserved in URLs)
export const IMG = {
  hero: 'https://customer-assets.emergentagent.com/job_brow-lash-van/artifacts/hwlxskah_Best-YUMI-lash-lift-vancouver.jpeg',
  client: 'https://customer-assets.emergentagent.com/job_brow-lash-van/artifacts/hwlxskah_Best-YUMI-lash-lift-vancouver.jpeg',
  storefront: 'https://customer-assets.emergentagent.com/job_brow-lash-van/artifacts/h3vr84ka_Pre%CC%81p%20Beauty%20Parlour-best-yumi-lash-lift-vancouver.jpg',
};

export const TEAM = [
  {
    name: 'Roselyn',
    role: 'Master Lash & Brow Artist',
    rating: 4.9,
    bio: 'A founding artist at Prép with over a decade of lash lift expertise. Specializes in tailoring YUMI and InLei treatments to every lash type and lifestyle.',
    img: 'https://cdn-partners-api.fresha.com/employee-avatars/processed/83823/medium/d646374a-6679-4c63-ab9e-7e3f79929cd7-C757102E-7538-4C0B-B848-4792BC53D6A6.jpeg',
    bookingUrl: 'https://www.fresha.com/p/roselyn-n-2978354',
  },
  {
    name: 'Maryna',
    role: 'Senior Lash & Brow Artist',
    rating: 5.0,
    bio: 'Known across Vancouver for delicate, gentle hands and flawless lift correction. The artist clients trust when their lash lift needs to be perfect.',
    img: 'https://cdn-partners-api.fresha.com/employee-avatars/processed/1490679/medium/a80006c5-3627-47cd-8a30-f96ea24da51b-IMG_3725.jpeg',
    bookingUrl: 'https://www.fresha.com/p/maryna-koicheva-5897618',
  },
  {
    name: 'Miriam',
    role: 'Master Lash Artist & Educator',
    rating: 4.9,
    bio: 'Master lash artist and certified educator. Trains the next generation of YUMI lash artists and delivers some of the most-loved lashes in the city.',
    img: 'https://cdn-partners-api.fresha.com/employee-avatars/processed/116036/medium/892c72e8-a6f9-4082-be9b-ebf3e1590ea3-Miriam-headshot.jpeg',
    bookingUrl: 'https://www.fresha.com/p/miriam-o-3149063',
  },
];

export const VIDEO = {
  process: {
    src: 'https://customer-assets.emergentagent.com/job_brow-lash-van/artifacts/6dgj6xzt_Yumi%20Lash%20lift%20Vancouver%20Pre%CC%81p.mov',
    alt: 'YUMI lash lift treatment in progress at Prép Beauty Parlour, Vancouver',
  },
  salon: {
    src: 'https://customer-assets.emergentagent.com/job_brow-lash-van/artifacts/bwhtdf52_Top-rated-lash-lift-extension-vancouver.mp4',
    alt: 'Top-rated lash lift and extensions in Vancouver at Prép Beauty Parlour',
  },
  tint: {
    src: 'https://customer-assets.emergentagent.com/job_brow-lash-van/artifacts/0kdiytsu_best-Yumi-lash-lift-vancouver.mp4',
    alt: 'Best YUMI lash lift in Vancouver — natural lifted lashes at Prép Beauty Parlour',
  },
};

export const SERVICES = [
  { name: 'YUMI Lash Lift & Tint', price: 150, duration: '75 min', featured: true },
  { name: 'YUMI Lash Lift + Brow Tint & Lamination', price: 225, duration: '80 min' },
  { name: 'YUMI Lash Lift + Brow Shaping, Tint & Lamination', price: 225, duration: '90 min' },
  { name: 'InLei Lash Filler® & Tint', price: 125, duration: '75 min', featured: true },
  { name: 'Lash Lift Rehab | Lift Reversal', price: 50, duration: '30 min' },
];

export const REVIEWS = [
  {
    name: 'Krista H.',
    date: 'May 2022',
    source: 'Fresha',
    text:
      'I arrived 10 minutes late for my appointment and was super pleased that Roselyn still accepted me today, despite me making her behind for her next client. She did a great job with my lash tint and I will definitely be returning!',
    highlight: 'lash tint',
  },
  {
    name: 'Kat D.',
    date: 'March 2026',
    source: 'Fresha',
    text: "Miriam does the best lashes I've ever had! 10/10 recommend",
    highlight: 'lashes',
  },
  {
    name: 'Paola O.',
    date: 'March 2026',
    source: 'Fresha',
    text:
      'I cannot recommend Maryna enough! I came in with a Yumi lash that was in desperate need of a fix. Maryna was incredibly professional and handled the correction with so much skill. She was extremely gentle with my eyes, and the results are absolutely amazing. My lashes look better than ever, thank you!!',
    highlight: 'Yumi lash',
  },
  {
    name: 'Alex G.',
    date: 'October 2023',
    source: 'Fresha',
    text:
      'Lovely experience as always. Nails were perfect — exactly what I wanted. Lash lift and tint is the best in Vancouver!',
    highlight: 'Lash lift and tint is the best in Vancouver',
  },
  {
    name: 'Trish K.',
    date: 'April 2025',
    source: 'Fresha',
    text:
      "It was a great experience. It's a retro building that's refurbished beautifully. They made coffee and my lash tech was awesome. 10/10 would come back when I'm in Vancouver.",
    highlight: 'lash tech',
  },
];

export const FAQS = [
  {
    q: 'What is YUMI lash lift and how does it work?',
    a: 'YUMI (Your Ultimate Moment Inspiration) is a French keratin lash lift system. It lifts and curls your natural lashes using a keratin-infused formula that conditions while it lifts — unlike standard lash lifts that use harsher perming chemicals. The treatment takes about 75 minutes and results last 8–12 weeks.',
  },
  {
    q: 'How much does a YUMI lash lift cost in Vancouver?',
    a: 'At Prép Beauty Parlour in downtown Vancouver, a YUMI Lash Lift & Tint costs $150. A YUMI Lash Lift + Brow Tint & Lamination package is $225. All YUMI treatments include a lash tint.',
  },
  {
    q: 'How long does a YUMI lash lift last?',
    a: 'A YUMI lash lift typically lasts 8–12 weeks, depending on your natural lash cycle and aftercare. This is longer than most standard lash lifts (6–8 weeks) because the keratin formula strengthens the lash structure while lifting.',
  },
  {
    q: 'Is YUMI lash lift better than regular lash lift?',
    a: "YUMI lash lift uses a keratin-infused formula that nourishes and strengthens your lashes during the lifting process — something standard lash lifts don't do. Over time, YUMI clients often see healthier, stronger lashes with repeat treatments. It also tends to last longer (8–12 weeks vs. 6–8 weeks for standard).",
  },
  {
    q: 'Are all artists at Prép Beauty Parlour YUMI certified?',
    a: "Yes. Every lash artist at Prép Beauty Parlour is YUMI certified — trained and authorised by Ellera Cosmetics, the official YUMI distributor in Canada. You don't need to request a specific artist to get a genuine YUMI treatment.",
  },
  {
    q: 'Where can I get a YUMI lash lift in downtown Vancouver?',
    a: "Prép Beauty Parlour at 1305 Burrard St offers YUMI lash lifts performed by fully certified artists. We're a 10-minute walk from Burrard SkyTrain Station, serving clients from the West End, Yaletown, Coal Harbour, and Davie Village.",
  },
  {
    q: "What's the difference between YUMI lashes and lash extensions?",
    a: 'YUMI lash lift curls and lifts your own natural lashes — nothing is added or glued on. Lash extensions attach synthetic lashes to your natural ones for more length and volume. YUMI is lower maintenance (no fills required), looks completely natural, and costs less to maintain.',
  },
  {
    q: 'What should I do before my YUMI lash lift appointment?',
    a: 'Come with clean, makeup-free lashes. Remove contact lenses before the appointment. Avoid waterproof mascara the day before. Do not curl your lashes on the day of your appointment.',
  },
  {
    q: 'Can I get YUMI lashes if I have sensitive eyes?',
    a: 'Most clients with sensitive eyes tolerate lash lifts well. YUMI\'s keratin-based formula is gentler than many standard lash lift solutions. If you have a history of eye allergies or reactions to cosmetic products, let us know when booking — we can discuss a patch test or recommend InLei Lash Filler® as a gentler alternative.',
  },
  {
    q: 'What is InLei Lash Filler and how is it different from YUMI?',
    a: 'InLei Lash Filler® is an Italian lash lift system that uses a filler formula to add volume and nourishment while lifting. It is gentler than YUMI and ideal for clients with fragile, over-processed, or shorter lashes. YUMI is better suited for clients wanting maximum lift and a keratin strengthening treatment. At Prép, both systems are available and your artist will recommend the right one during the consultation.',
  },
  {
    q: 'How do I care for my lash lift after the appointment?',
    a: 'For the first 24–48 hours: avoid water, steam, saunas, swimming, and eye makeup. Do not rub or touch your lashes. Sleep on your back if possible. After 48 hours, resume normal skincare but avoid oil-based products near your eyes — oils can break down the lift. A lash conditioning serum can help maintain results between appointments.',
  },
  {
    q: 'Can I get a lash lift and lash extensions at the same time?',
    a: 'No — a lash lift and lash extensions are not compatible at the same time. A lash lift works on natural lashes, and applying extensions over a freshly lifted lash could compromise both services. If you currently have extensions, they must be fully removed and your natural lashes given time to recover before a lash lift can be performed.',
  },
  {
    q: 'Is YUMI lash lift safe during pregnancy?',
    a: 'Many clients safely receive lash lifts during pregnancy, but we recommend consulting your healthcare provider first, as individual sensitivities can change during pregnancy. Let your artist know at the time of booking so we can take extra care with ventilation and ensure you\'re comfortable throughout your appointment.',
  },
  {
    q: 'How do I book a lash lift appointment in Vancouver at Prép?',
    a: 'Book online through Fresha at prepbeautyparlour.com for real-time availability. You can also call us at 604-764-6452 during business hours. We\'re at 1305 Burrard St, Vancouver — steps from Burrard SkyTrain.',
  },
];

export const PROCESS_STEPS = [
  {
    n: '01',
    title: 'Consultation',
    duration: '5 min',
    body:
      'We assess your natural lash length, curl, and health — and help you choose between YUMI and InLei based on what your lashes actually need.',
  },
  {
    n: '02',
    title: 'Cleanse & Prep',
    duration: '10 min',
    body:
      'Your lashes are thoroughly cleansed and dried. A silicone shield is placed on your eyelid to shape the lift.',
  },
  {
    n: '03',
    title: 'The Lift',
    duration: '45–50 min',
    body:
      'Your lashes are carefully combed over the shield. The lifting and setting lotions are applied. For YUMI: the keratin treatment follows. For InLei: the filler formula volumizes and nourishes.',
  },
  {
    n: '04',
    title: 'Tint',
    duration: '10 min',
    body:
      'A lash tint is applied to darken and define your lashes — no mascara needed for 6–8 weeks.',
  },
  {
    n: '05',
    title: 'Nourishing Finish',
    duration: '—',
    body:
      'A conditioning serum is applied to lock in moisture and keep your lashes healthy between lifts.',
  },
];

export const NEIGHBORHOODS = [
  'West End',
  'Yaletown',
  'Davie Village',
  'Kitsilano',
  'Coal Harbour',
  'Downtown Vancouver',
];
